<template>
    <div class="business-content-main" v-loading="loading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">扫码</div>
                <el-input
                    class="search-name"
                    ref="inputdata"
                    v-model="scanData"
                    clearable
                    placeholder="请扫描加工单号或商品标签"
                    size="small"
                    style="width: 250px"
                    @blur="inputblur()"
                    @change="inputDataChange()"
                ></el-input>
                <el-button v-if="fromWarehouseType == 0" size="small" class="search-btn btn-primary" @click="submit()">提交出库</el-button>
                <div class="search-name" v-if="orderCode">加工单号：{{ orderCode }}</div>
                <div class="search-name" v-if="fromWarehouseName">出库仓库：{{ fromWarehouseName }} <span v-if="fromWarehouseType == 1" style="color: #8492a6">(前置仓)</span></div>
                <div class="search-name" v-if="toWarehouseName">入库仓库：{{ toWarehouseName }} <span v-if="toWarehouseType == 1" style="color: #8492a6">(前置仓)</span></div>
                <div class="search-name" style="color: red">（请先扫加工单，后扫商品标签。确保焦点在标签输入框内，并检查电脑的输入法是否英文输入）</div>
            </div>
        </div>
        <div>
            <el-row :gutter="20" class="table-ctn">
                <el-col :span="12">
                    <div class="grid-content">
                        <el-table :header-cell-style="{ background: '#F2F6FC' }" border :data="dataList" style="width: 100%" empty-text="请扫描加工单上的二维码">
                            <el-table-column label="汽配编码" show-overflow-tooltip min-width="100px" prop="APCode"></el-table-column>
                            <el-table-column label="汽配名称" show-overflow-tooltip min-width="100px" prop="GoodName"></el-table-column>
                            <el-table-column label="适用车型" show-overflow-tooltip min-width="100px" prop="AutoSerise"></el-table-column>
                            <el-table-column label="库存数" show-overflow-tooltip width="80px" prop="Inventory"></el-table-column>
                            <el-table-column label="待出数量" show-overflow-tooltip width="80px">
                                <template slot-scope="scope">
                                    <div
                                        :class="{
                                            'check-class': scope.row.Count > 0
                                        }"
                                    >
                                        {{ scope.row.Count }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="扫码数量" show-overflow-tooltip width="80px">
                                <template slot-scope="scope">
                                    <div
                                        :class="{
                                            'check-class-enough': scope.row.Count - scope.row.ScanCount == 0 && scope.row.ScanCount > 0
                                        }"
                                    >
                                        {{ scope.row.ScanCount }}
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="grid-content">
                        <div class="labelzone">
                            <el-card class="box-card" v-for="(item, index) in cardList" :key="index">
                                <div style="padding: 14px">
                                    <span class="goodname">{{ item.GoodName }}</span>
                                    <div class="bottom clearfix">
                                        <span class="apcode">{{ item.APCode }}</span>
                                        <span class="button">
                                            {{ item.PackingSpec + ' ' + item.Unit }}
                                        </span>
                                    </div>
                                    <div class="bottom clearfix">
                                        <time class="time">{{ item.LabelCode }}</time>
                                        <el-button type="text" class="button" icon="el-icon-delete" style="color: red" @click="delItem(item)"></el-button>
                                    </div>
                                </div>
                            </el-card>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <audio ref="audio" controls hidden></audio>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
export default {
    name: 'OrderScan',
    components: {
        breadcrumb
    },
    data() {
        return {
            stype: 0,
            loading: false,
            fromWarehouseName: '',
            toWarehouseName: '',
            fromWarehouseType: 0,
            toWarehouseType: 0,
            oid: '',
            orderId: '',
            dataList: [],
            scanData: '',
            labels: [],
            cardList: [],
            orderCode: '',
            firstScanOrder: true,
            currectAudio: '/download/currect.mp3',
            errorAudio: '/download/error.mp3',
            allOutAudio: '/download/allout.mp3',
            wrongXSAudio: '/download/wrongxs.mp3',
            repetLabel: '/download/repetlabel.mp3',
            enoughAudio: '/download/enough.mp3',
            delAudio: '/download/del.mp3',
            cancelAudio: '/download/cancel.mp3'
        };
    },
    mounted() {
        this.stype = this.$route.query.stype;
        if (this.stype == 1) {
            this.oid = this.$route.query.PTOId;
            this.getOrderDetail('', this.oid);
        }
    },
    methods: {
        getOrderDetail(orderCode, orderId) {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/GetProcessTransOrderGoods',
                    data: {
                        PTOId: orderId,
                        PTOCode: orderCode
                    }
                })
                .then(res => {
                    let data = res.data;
                    if (data.FromWarehouseType == 1) {
                        that.firstScanOrder = true;
                        that.aplayAudio(that.errorAudio);
                        that.$util.warningMsg('提醒：加工单出仓仓库是前置仓哟');
                        that.dataList = [];
                        that.oid = '';
                        that.orderId = '';
                        return;
                    }
                    if (data.State == 0) {
                        that.firstScanOrder = true;
                        that.aplayAudio(that.errorAudio);
                        that.$util.warningMsg('提醒：加工单未提交，请先提交再进行出仓');
                        that.dataList = [];
                        that.oid = '';
                        that.orderId = '';
                        return;
                    }
                    if (data.State == 3) {
                        that.firstScanOrder = true;
                        that.aplayAudio(that.errorAudio);
                        that.$util.warningMsg('提醒：加工单已出仓完成');
                        that.dataList = [];
                        that.oid = '';
                        that.orderId = '';
                        return;
                    }
                    if (data.State == 4) {
                        that.firstScanOrder = true;
                        that.aplayAudio(that.errorAudio);
                        that.$util.warningMsg('提醒：该加工单已入仓完成');
                        that.oid = '';
                        that.orderId = '';
                    }
                    if (data.State == 7) {
                        that.firstScanOrder = true;
                        that.aplayAudio(that.errorAudio);
                        that.$util.warningMsg('提醒：该加工单已出仓完成');
                        that.oid = '';
                        that.orderId = '';
                    }  else {
                        that.aplayAudio(that.currectAudio);
                    }
                    that.dataList = [];
                    that.orderId = data.PTOId;
                    that.orderCode = data.PTOCode;
                    that.fromWarehouseType = data.FromWarehouseType;
                    that.toWarehouseType = data.ToWarehouseType;
                    that.fromWarehouseName = data.FromWarehouseName;
                    that.toWarehouseName = data.ToWarehouseName;
                    let DetailList = data.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        that.dataList.push({
                            GoodsId: DetailList[i].EntpTempGoodsId,
                            APCode: DetailList[i].APCode,
                            GoodName: DetailList[i].GoodName,
                            Unit: DetailList[i].Unit,
                            AutoSerise: DetailList[i].AutoSerise,
                            Inventory: DetailList[i].Inventory,
                            Count: DetailList[i].TCount,
                            ScanCount: 0,
                            SortField: 0
                        });
                    }
                });
        },
        // 失去焦点
        inputblur() {
            let that = this;
            // FireFox 和 IE 失去焦点，blur直接执行focus 不会生效，加个延时
            setTimeout(() => {
                that.$refs.inputdata.focus();
            }, 100);
        },
        inputDataChange() {
            let that = this;
            if (that.scanData.indexOf('JG') > -1) {
                that.orderCode = that.scanData;
                if (that.firstScanOrder) {
                    if (that.scanData.length == 17) {
                        that.firstScanOrder = false;
                        that.getOrderDetail(that.scanData, '');
                    } else {
                        that.aplayAudio(that.errorAudio);
                        that.$util.warningMsg('加工单号长度不符合规则！请检查输入法是否为英文输入法');
                    }
                } else {
                    that.$confirm('已经有未提交出仓加工单，是否确定放弃提交？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: false
                    })
                        .then(() => {
                            that.firstScanOrder = true;
                            that.labels = [];
                            that.cardList = [];
                            that.dataList = [];
                            this.getOrderDetail(that.orderCode, '');
                        })
                        .catch(() => {});
                }
            } else if (that.scanData.indexOf('AP-') > -1) {
                if (that.scanData.length == 20) {
                    that.$util
                        .axiosGet({
                            url: '/api/EntpTransferOrder/CheckEntpProcessTransOrderOutGoods',
                            data: {
                                PTOId: that.orderId,
                                LabelCode: that.scanData
                            }
                        })
                        .then(res => {
                            let data = res.data;
                            if (data) {
                                let datalist = that.dataList;
                                let scount = 0;
                                let needCount = 0;
                                var label = {
                                    APCode: data.APCode,
                                    GoodName: data.GoodName,
                                    PackingSpec: data.PackingSpec,
                                    LabelCode: data.LabelCode,
                                    Unit: data.Unit,
                                    LabelId: data.LabelId,
                                    GoodsId: data.GoodsId
                                };
                                var isRepet = false;
                                if (that.cardList.length > 0) {
                                    that.cardList.forEach(element => {
                                        if (element.LabelCode == label.LabelCode) {
                                            isRepet = true;
                                            that.$util.warningMsg('重复标签！');
                                            return;
                                        }
                                    });
                                }
                                if (isRepet) {
                                    that.aplayAudio(that.repetLabel);
                                    return;
                                }

                                if (datalist && datalist.length > 0) {
                                    for (let i = 0; i < datalist.length; i++) {
                                        if (datalist[i].GoodsId == label.GoodsId) {
                                            scount = datalist[i].ScanCount;
                                            needCount = datalist[i].Count;

                                            if (scount + label.PackingSpec <= needCount) {
                                                datalist[i].ScanCount += label.PackingSpec;
                                                that.cardList.push(label);
                                                that.labels.push(data.LabelId);
                                            } else {
                                                that.aplayAudio(that.enoughAudio);
                                                that.$util.warningMsg('标签的商品总数大于加工待出的数量！');
                                                return;
                                            }
                                            datalist[i].SortField = datalist[i].Count - datalist[i].ScanCount == 0 && datalist[i].ScanCount > 0 ? 1 : 0;
                                        }
                                    }
                                    datalist.sort(function (a, b) {
                                        return a.SortField - b.SortField;
                                    });
                                    that.aplayAudio(that.currectAudio);
                                }
                            } else {
                                that.aplayAudio(that.errorAudio);
                            }
                        })
                        .catch(() => {
                            that.aplayAudio(that.errorAudio);
                        });
                } else if (that.scanData.length != 0) {
                    that.aplayAudio(that.errorAudio);
                    that.$util.warningMsg('标签码长度不符合规则！请检查输入法是否为英文输入法');
                }
            }
            that.scanData = '';
        },
        delItem(item) {
            let that = this;
            if (item) {
                this.cardList.splice(this.cardList.indexOf(item), 1);
                this.labels.splice(this.labels.indexOf(item.LabelId), 1);
                let datalist = that.dataList;
                if (datalist && datalist.length > 0) {
                    for (let i = 0; i < datalist.length; i++) {
                        if (datalist[i].GoodsId == item.GoodsId) {
                            datalist[i].ScanCount -= item.PackingSpec;
                            datalist[i].SortField = datalist[i].Count - datalist[i].ScanCount == 0 && datalist[i].ScanCount > 0 ? 1 : 0;
                            datalist.sort(function (a, b) {
                                return a.SortField - b.SortField;
                            });
                            that.dataList = datalist;
                            return;
                        }
                    }
                }
            }
        },
        submit() {
            let that = this;
            if (that.labels.length == 0) {
                that.$util.warningMsg('无标签信息，请重新扫码');
                return;
            }
            let datalist = that.dataList;
            if (datalist && datalist.length > 0) {
                let scount = 0;
                let needCount = 0;
                for (let i = 0; i < datalist.length; i++) {
                    0;
                    scount = datalist[i].ScanCount;
                    needCount = datalist[i].Count;
                    if (scount != needCount) {
                        that.aplayAudio(that.errorAudio);
                        that.$util.warningMsg('所扫的商品标签数不够加工单出仓数！请确认后重新操作');
                        return;
                    }
                }
            } else {
                that.$util.warningMsg('提交的数据异常，请刷新重新操作');
                return;
            }

            that.$confirm('确定提交加工出仓吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: false
            }).then(() => {
                this.loading = true;
                this.$util
                    .axiosPost({
                        url: '/api/EntpTransferOrder/SubmitEntpProcessScanLabelOut',
                        data: {
                            TOId: that.orderId,
                            LabelIdList: that.labels
                        }
                    })
                    .then(res => {
                        if (res.errcode == 0) {
                            that.$util.successMsg('加工出仓成功');
                            that.firstScanOrder = true;
                            that.labels = [];
                            that.cardList = [];
                            that.loading = false;
                        } else {
                            that.$util.successMsg(res.errmsg);
                        }
                    })
                    .catch(() => {
                        that.loading = false;
                    });
            });
        },
        aplayAudio(audioUrl) {
            this.$refs.audio.src = audioUrl;
            this.$nextTick(res => {
                this.$refs.audio.load();
                this.$refs.audio.play();
            });
        }
    }
};
</script>
<style lang="less" scoped>
.labelzone {
    display: flex;
    flex-wrap: wrap-reverse;
    padding-left: 20px;
    width: 100%;
    height: 100%;
    margin-bottom: 30px;
}
.labelk {
    display: flex;
    flex-direction: column;
}
.box-card {
    width: 220px;
    margin: 5px;
}

.time {
    font-size: 13px;
    color: #999;
}

.bottom {
    margin-top: 13px;
    line-height: 12px;
}

.button {
    padding: 0;
    float: right;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: '';
}

.clearfix:after {
    clear: both;
}

.goodname {
    font-size: 18px;
    line-height: 24px;
}
.apcode {
    font-size: 15px;
}
.check-class {
    color: red;
    font-weight: bold;
}
.check-class-enough {
    color: green;
    font-weight: bold;
}
</style>
